import React from 'react'
import { Stack, Alert } from '@mantine/core'
import AppCard from '../../app/common/ui/AppCard'
import { FiInfo } from 'react-icons/fi'
import AppButton from '../../app/common/ui/AppButton'
import AppInput from '../../app/common/ui/AppInput'
import type { SlopLibraryFeed } from './hooks/useSlopLibraryFeed'

type Props = Pick<
  SlopLibraryFeed,
  | 'embedUrl'
  | 'setEmbedUrl'
  | 'embedTitle'
  | 'setEmbedTitle'
  | 'embedDescription'
  | 'setEmbedDescription'
  | 'embedLoading'
  | 'embedError'
  | 'handleAddEmbed'
>

export default function SlopEmbedAdmin ({
  embedUrl,
  setEmbedUrl,
  embedTitle,
  setEmbedTitle,
  embedDescription,
  setEmbedDescription,
  embedLoading,
  embedError,
  handleAddEmbed
}: Props) {
  return (
    <AppCard
      sx={{
        background: 'var(--gs-surface2)',
        border: '1px solid var(--gs-border)',
        maxWidth: 500
      }}
    >
      <Stack gap="md">
        {embedError && (
          <Alert icon={<FiInfo />} title="Error" color="red">
            {embedError}
          </Alert>
        )}
        <AppInput
          label="Embed URL"
          placeholder="https://youtube.com/watch?v=..."
          value={embedUrl}
          onChange={(e) => setEmbedUrl(e.currentTarget.value)}
          disabled={embedLoading}
        />
        <AppInput
          label="Title"
          placeholder="Video title"
          value={embedTitle}
          onChange={(e) => setEmbedTitle(e.currentTarget.value)}
          disabled={embedLoading}
        />
        <AppInput
          label="Description"
          placeholder="Brief description"
          value={embedDescription}
          onChange={(e) => setEmbedDescription(e.currentTarget.value)}
          multiline
          minRows={3}
          disabled={embedLoading}
        />
        <AppButton onClick={() => void handleAddEmbed()} loading={embedLoading}>
          Add Embed
        </AppButton>
      </Stack>
    </AppCard>
  )
}
